export function resolveAudioTrack(videoInfo, options) {
  const audioTracks = videoInfo['audio_tracks'] || [];

  if (audioTracks.length === 0) {
    return undefined;
  }

  if ('defaultAudioTrack' in options) {
    // defaultAudioTrack could be int, stringified int or string (e.g. 'en')
    let defaultAudioTrack = parseInt(options['defaultAudioTrack']);
    if (Number.isNaN(defaultAudioTrack)) {
      // suppose that the value is like 'en'
      defaultAudioTrack = options['defaultAudioTrack'];
    }
    // TODO: delete options.defaultAudioTrack;

    let track;
    if (typeof defaultAudioTrack === 'number') {
      track =
        audioTracks.find((t) => t.id === defaultAudioTrack) ||
        audioTracks[defaultAudioTrack];
    } else {
      track = audioTracks.find((t) => t.lang === defaultAudioTrack);
    }

    if (track) {
      return track.id;
    }
  }

  const activeTrack = audioTracks.find((track) => track.is_active);

  return activeTrack ? activeTrack.id : audioTracks[0].id;
}

export function getSrcOfQuality(selectedBitrate, qualitiesList) {
  if (selectedBitrate === undefined || selectedBitrate === null) {
    selectedBitrate = -1;
  } else if (typeof selectedBitrate === 'string') {
    selectedBitrate = parseInt(selectedBitrate);
  }
  let quality;
  if (qualitiesList && qualitiesList.length > 0) {
    for (let i = 0, l = qualitiesList.length; i < l; ++i) {
      if (qualitiesList[i].bitrate == selectedBitrate && qualitiesList[i].src) {
        quality = qualitiesList[i];
        break;
      }
    }
  }
  return quality;
}

export function disableSubtitles(video) {
  if (video) {
    let tracks = video.textTracks;
    if (tracks && tracks.length > 0) {
      for (let i = 0, l = tracks.length; i < l; ++i) {
        if (tracks[i].kind === 'subtitles') {
          tracks[i].mode = 'disabled';
        }
      }
    }
    setTimeout(() => {
      if (video && !isSubtitlesReallyTurnedOff(video.textTracks)) {
        disableSubtitles(video);
      }
    }, 1000);
  }
}

function isSubtitlesReallyTurnedOff(textTracks) {
  for (let i = 0, l = textTracks.length; i < l; ++i) {
    if (textTracks[i].kind === 'subtitles') {
      if (textTracks[i].mode !== 'disabled') {
        return false;
      }
    }
  }
  return true;
}

export function isIOS() {
  return (
    navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone')
  );
}
